import { useState } from 'react';

export type DataRoomTab =
  | 'general'
  | 'site_terms'
  | 'content'
  | 'documents'
  | 'access';

export const dataRoomTabs: Array<{ label: string; id: DataRoomTab }> = [
  {
    label: 'General',
    id: 'general',
  },
  {
    label: 'Site terms',
    id: 'site_terms',
  },
  {
    label: 'Content',
    id: 'content',
  },
  {
    label: 'Documents',
    id: 'documents',
  },
  {
    label: 'Access',
    id: 'access',
  },
];

export const useDataRoomTabs = () => {
  const [selectedTab, setSelectedTab] = useState<DataRoomTab>('general');

  return {
    selectedTab,
    setSelectedTab,
  };
};
